import { handleResponse } from 'api/utils';
import { getAprilApiHost } from 'utils/env';

import { firebaseApp } from './firebase';

export type LoginRequest =
  | {
      MarketplaceUserLogin: {
        marketplaceId: string;
        emailAddress: string;
        password: string;
      };
    }
  | {
      MerchantUserLogin: {
        merchantId: string;
        emailAddress: string;
        password: string;
      };
    };

export type LoginResponse = {
  customToken: string;
  expiresAt: string;
};

export const login = async (tenantId: string, payload: LoginRequest) => {
  const { customToken } = await fetch(`${await getAprilApiHost()}/auth/login`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);

  return loginWithToken(tenantId, customToken);
};

export const logout = async () => {
  const firebaseAuth = firebaseApp.auth();
  return firebaseAuth.signOut();
};

export const loginWithToken = async (tenantId: string, token: string) => {
  const firebaseAuth = firebaseApp.auth();
  firebaseAuth.tenantId = tenantId;
  await firebaseAuth.setPersistence('session');
  return firebaseAuth.signInWithCustomToken(token);
};
